import React from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import {ReactComponent as Hint} from './files/Hint.svg';

export default (props) => <SvgIcon component={Hint} {...props} />;
